import React from "react";
import { useTranslation } from "react-i18next";
import isFunction from "lodash/isFunction";
import { fieldRules } from "../methods";
import Form from "../index";
import { InputNumber } from "../../Input";

export const FORM_ITEM_NUMBER = "form-number";

const FormItemNumber = (props) => {
  const { name, label, required, placeholder, rules = [], fieldProps = {}, visible = true, ...rest } = props;
  const { t } = useTranslation();

  if (!visible) {
    return null;
  }

  const formField = (
    <Form.Item
      name={name}
      label={t(label)}
      rules={fieldRules(
        {
          required: required
            ? {
                message: t("container.form_errors.required")
              }
            : false
        },
        rules
      )}
      {...rest}
    >
      <InputNumber placeholder={t(placeholder)} {...fieldProps} />
    </Form.Item>
  );

  if (isFunction(visible)) {
    return (
      <Form.Item noStyle shouldUpdate>
        {(formInstance) => {
          const isVisible = visible(formInstance);
          if (isVisible) {
            return isVisible ? formField : null;
          }
        }}
      </Form.Item>
    );
  }

  return formField;
};

export default FormItemNumber;
